import * as React from 'react';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const HockeyColored = ({ size = 'xsmall' }: IconProps) => {
    return (
        <svg width={IconSizes[size]} height={IconSizes[size]} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <g id="Hockey" fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <path
                    d="M7.652 6.603c3.646-3.582 6.916-5.073 9.809-4.472l4.037 4.472c1.446 1.447-.775 5.167-5.414 9.805-4.638 4.64-8.133 6.655-9.58 5.208l-4.04-4.043c-.187-3.732 1.543-7.388 5.188-10.97z"
                    fill="#65697E"
                />
                <path
                    d="M15.667 15.666c-1.972 1.972-4.053 3.58-5.86 4.528-1.878.984-2.66.825-2.752.732l-2.162-2.162a10.604 10.604 0 0 0 1.86-.783c1.98-1.039 4.234-2.773 6.345-4.884 2.606-2.606 4.925-5.743 5.664-8.209l2.165 2.165c.486.487-.754 4.107-5.26 8.613M8.33 8.33c3.907-3.907 7.149-5.359 8.259-5.359.169 0 .289.034.354.1.487.486-.755 4.106-5.26 8.612-1.972 1.972-4.053 3.58-5.86 4.527-1.878.985-2.66.825-2.753.732-.486-.486.755-4.106 5.26-8.612m14.01-2.69-3.983-3.984c-2.125-2.122-7.42 1.238-11.441 5.26-4.021 4.022-7.383 9.317-5.26 11.44L5.64 22.34c.352.353.904.655 1.757.655.81 0 1.894-.272 3.338-1.03 1.98-1.039 4.235-2.774 6.345-4.885 4.022-4.022 7.384-9.317 5.26-11.44"
                    fill="#0D0E0F"
                />
            </g>
        </svg>
    );
};
